import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from '../app-routing.module';
import { DnCommonModule } from '../dn-common/dn-common.module';
import { DnErrorDisplayModule } from '../dn-common/dn-error-display/dn-error-display.module';
import { AppFormsModule } from '../forms/app-forms.module';
import { YmlLoaderService } from '../shared/services/yml-loader.service';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { JourneyChangeEmailComponent } from './journey-change-email/journey-change-email.component';
import { JourneyChangePasswordComponent } from './journey-change-password/journey-change-password.component';
import { JourneyEsigningComponent } from './journey-esigning/journey-esigning.component';
import { JourneyLoginComponent } from './journey-login/journey-login.component';
import { JourneyLogoutComponent } from './journey-logout/journey-logout.component';
import { JourneyPasswordResetComponent } from './journey-password-reset/journey-password-reset.component';
import { JourneyRecoverUsernameComponent } from './journey-recover-username/journey-recover-username.component';
import { JourneyUpdateTouComponent } from './journey-update-tou/journey-update-tou.component';
import { ClienBaseComponent } from './user-types/client-partner/client-base/client-base.component';
import { ClientEmailVerifiedComponent } from './user-types/client-partner/client-email-verified/client-email-verified.component';
import { ClientRegistrationComponent } from './user-types/client-partner/client-registration/client-registration.component';
import { EmployerBaseComponent } from './user-types/employer/employer-base/employer-base.component';
import { EmployerEsignComponent } from './user-types/employer/employer-esign/employer-esign.component';
import { ProviderBaseComponent } from './user-types/provider/provider-base/provider-base.component';
import { ProviderEmailVerifiedComponent } from './user-types/provider/provider-email-verified/provider-email-verified.component';
import { ProviderLoginComponent } from './user-types/provider/provider-login/provider-login.component';
import { ProviderPasswordResetComponent } from './user-types/provider/provider-password-reset/provider-password-reset.component';
import { ProviderProfileComponent } from './user-types/provider/provider-profile/provider-profile.component';
import { ProviderRegistrationComponent } from './user-types/provider/provider-registration/provider-registration.component';
import { ProviderUsernameForgotComponent } from './user-types/provider/provider-username-forgot/provider-username-forgot';

@NgModule({
  providers: [provideNgxMask()],
  declarations: [
    ProviderLoginComponent,
    ProviderBaseComponent,
    ProviderPasswordResetComponent,
    ProviderRegistrationComponent,
    ProviderUsernameForgotComponent,
    ProviderEmailVerifiedComponent,
    JourneyPasswordResetComponent,
    JourneyRecoverUsernameComponent,
    JourneyLoginComponent,
    JourneyChangeEmailComponent,
    ProviderProfileComponent,
    JourneyChangePasswordComponent,
    JourneyLogoutComponent,
    JourneyUpdateTouComponent,
    ClientRegistrationComponent,
    EmployerBaseComponent,
    ClienBaseComponent,
    ClientEmailVerifiedComponent,
    EmployerEsignComponent,
    JourneyEsigningComponent
  ],
  imports: [
    NgbNavModule,
    AppRoutingModule,
    CommonModule,
    AppFormsModule,
    FormsModule,
    DnErrorDisplayModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useExisting: YmlLoaderService
      },
      defaultLanguage: 'en'
    }),
    DnCommonModule
  ],
})
export class JourneyModule { }
